import { render } from "./AffiliateConfigurationPassword.vue?vue&type=template&id=b110ad80&scoped=true"
import script from "./AffiliateConfigurationPassword.vue?vue&type=script&lang=js"
export * from "./AffiliateConfigurationPassword.vue?vue&type=script&lang=js"

import "./AffiliateConfigurationPassword.vue?vue&type=style&index=0&id=b110ad80&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b110ad80"]])

export default __exports__